import Component from "../classes/Component";
import Swiper, { Navigation, EffectCoverflow } from "swiper";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/pagination";

// init Swiper:

export default class HomeSliderTalents extends Component {
  constructor() {
    super({
      element: "[data-components-slider-home-talents]",
      elements: {},
    });
    this.slider = null;
    this.init();
  }
  init() {
    if (this.element) {
      this.listenResize();
      this.switchSlider();
    }
  }
  switchSlider() {
    if (this.slider != null) {
      this.slider.destroy(true, true);
    }

    if (window.innerWidth >= 768) {
      this.initSliderDesktop();
    } else {
      this.initSliderMobile();
    }
  }
  listenResize() {
    window.addEventListener("resize", () => {
      this.switchSlider();
    });
  }

  initSliderMobile() {
    this.slider = new Swiper(this.element, {
      // configure Swiper to use module
      slidesPerView: 1.2,
      spaceBetween: 20,
    });
  }
  initSliderDesktop() {
    this.slider = new Swiper(this.element, {
      // configure Swiper to use modules
      initialSlide: 0,
      loop: true,
      allowTouchMove: false,
      //freeMode: true,
      modules: [Navigation, EffectCoverflow],
      effect: 'coverflow',
      breakpoints: {
        768: {
          coverflowEffect: {
            rotate: 0,
            stretch: 70,
            depth: 150,
            modifier: 1.5,
            slideShadows: false,
          },
        },
        1024: {
          coverflowEffect: {
            rotate: 0,
            stretch: 96,
            depth: 200,
            modifier: 1.5,
            slideShadows: false,
          },
        },
        1440: {
          coverflowEffect: {
            rotate: 0,
            stretch: 130,
            depth: 220,
            modifier: 1.5,
            slideShadows: false,
          },
        },
        1792: {
          coverflowEffect: {
            rotate: 0,
            stretch: 150.5,
            depth: 265,
            modifier: 1.5,
            slideShadows: false,
          },
        }
      },
      centeredSlides: true,
      slidesPerView: 'auto',
      //centeredSlides: true,
      // If we need pagination
      navigation: {
        prevEl: ".swiper-button-next",
      },
    });
  }
}
